import React, { FC } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useOfferDetailModel } from "../offerDetailModel";
export const TransportFormBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        isDisabeld,editFormVal, addFormVal
    } = useOfferDetailModel();
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    const { getSelectedDictOne } = useDictModel(() => []);

    const transportFormItem: IYhFormItemsBox = {
        title: "运输信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px", width: "100%" },
        contentClass: "pr-2",
        disabled:formVal.status=='quote.finish',
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易条款",
                fieldName: "clause",
                options: getSelectedDictOne(DictCodeEnmu.TRADE_CLAUSE),
                
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "transportMode",
                options: getSelectedDictOne(DictCodeEnmu.TRANSPORT_MODE),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "目的地",
                fieldName: "destination",
            }, {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: "分批",
                fieldName: "batches",
                span: 3,
                labelCol: { span: 8, offset: 8 },
            }, {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: "装船",
                fieldName: "transship",
                span: 3
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "装货港",
                fieldName: "shipment",
                options: getSelectedDictOne(DictCodeEnmu.LOAD_PORT),
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "卸货港",
                fieldName: "discharge",
                options: getSelectedDictOne(DictCodeEnmu.DISCHARTGE_PORT),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货代公司",
                fieldName: "agentCompany",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "唛头",
                fieldName: "shippingMark",
            }
        ]
    };

    return (
        <YhFormItemsBox {...transportFormItem} />
    )
}